import { createFileRoute } from '@tanstack/react-router';
import { OperationsNewQuotePage } from '@/features/operations/new-quote-page';

export const Route = createFileRoute('/operations/quotes/new')({
  component: OperationsNewQuoteRoute,
});

function OperationsNewQuoteRoute() {
  return <OperationsNewQuotePage />;
}
